import React, { Component } from 'react';
import _ from 'lodash';
import GreyGiftSvg from '../GreyGiftSvg';

class EmptyGiftListIndicator extends Component {
  constructor(props) {
    super(props);

    const { giftList } = props;
    if (!_.isString(giftList)) throw new Error('prop giftList has to be a string');

    let state;
    switch (giftList) {
      case 'registered':
        state = {
          topMessage: 'Tu lista de regalos está vacía',
          bottomMessageFirstHalf: 'Agrega regalos a tu lista y compártela con tus invitados',
          bottomMessageSecondHalf: 'con tus invitados.',
        };
        break;
      case 'received':
        state = {
          topMessage: 'Sin regalos recibidos',
          bottomMessageFirstHalf: 'No hay resultados para este tipo de regalo',
          bottomMessageSecondHalf: 'Comparte tu lista a tus invitados para recibir regalos.',
          bottomMessageSecondHalf2: 'Agrega más regalos y descubre cuáles incluyen bonificación.',
        };
        break;
      case 'personalPurchases':
        state = {
          topMessage: 'Sin compras personales',
          // bottomMessageFirstHalf: 'No hay resultados para este tipo de regalo',
          bottomMessageFirstHalf: 'Empieza a explorar nuestros productos y realiza tu primera compra hoy',
          bottomMessageSecondHalf: 'Agrega más regalos y descubre cuáles incluyen bonificación.',
        };
        break;
      case 'received_noSearchResults':
        state = {
          topMessage: 'Tu lista de regalos está vacía',
          bottomMessageFirstHalf: 'No hay resultados para este tipo de regalo',
          bottomMessageSecondHalf: 'Agrega más regalos y descubre cuáles incluyen bonificación.',
        };
        break;
      case 'registered_noSearchResults':
        state = {
          topMessage: 'Tu lista de regalos está vacía',
          bottomMessageFirstHalf: 'No hay resultados para este tipo de regalo',
          bottomMessageSecondHalf: 'Agrega más regalos y descubre cuáles incluyen bonificación.',
        };
        break;
      case 'personalPurchases_noSearchResults':
        state = {
          topMessage: 'Tu lista de regalos está vacía',
          bottomMessageFirstHalf: 'No hay resultados para este tipo de regalo',
          bottomMessageSecondHalf: 'Agrega más regalos y descubre cuáles incluyen bonificación.',
        };
        break;
      case 'guestView':
        state = {
          topMessage: 'La lista de regalos esta vacía',
          bottomMessageFirstHalf: 'El festejado aún no ha agregado regalos a su mesa',
          bottomMessageSecondHalf: '¡Vuelve más tarde para ver si ha agregado regalos!',
        };
        break;
      default:
        throw new Error(`giftList ${giftList} not expected`);
    }

    this.state = state;
  }

  render() {
    const { giftList } = this.props;
    let greyGiftSvgType = '';
    if (giftList === 'registered' || giftList === 'guestView') {
      greyGiftSvgType = 'closed';
    } else if (giftList === 'received') {
        greyGiftSvgType = 'boxopen';
    } else if (giftList === 'received_noSearchResults' || giftList === 'registered_noSearchResults' || giftList === 'personalPurchases_noSearchResults') {
      greyGiftSvgType = 'closed2';
    } else if (giftList === 'personalPurchases') {
      greyGiftSvgType = 'boxopen';
    } else {
      greyGiftSvgType = 'closed';
    }

    return (
      <div className={`row text-center ${giftList === "guestView"? 'guestView-row' : ''}`} style={{ color: 'gray', fontSize: '1.8rem', ...this.props.style }}>
        {/* <div className="col-xs-12" style={{ fontSize: '2.4rem' }}>
          <b>{this.state.topMessage}</b>
        </div> */}
        {giftList == 'received' ? (
          <>
            <div className="col-xs-12 bottomMessageFirstHalf  toptext-margin">
                  {this.state.topMessage}
                </div>
                <div className="col-xs-12" style={{ margin: '0' }}>
                  <GreyGiftSvg type={greyGiftSvgType} width="15%" height="auto" />
                </div>            
                <div className="col-xs-12 bottomMessageSecondHalf  bottomtext-margin">
                  {this.state.bottomMessageSecondHalf}
                </div>
          </>
        ) : (giftList == 'registered' || giftList == 'personalPurchases' || giftList == 'guestView' ? (
          <>
            <div className="col-xs-12 bottomMessageFirstHalf  toptext-margin">
              {this.state.topMessage}
            </div>
            <div className="col-xs-12" style={{ margin: '0' }}>
              <GreyGiftSvg type={greyGiftSvgType} width="15%" height="auto" />
            </div>            
            <div className="col-xs-12 bottomMessageSecondHalf  bottomtext-margin">
                <div className='personal-purchases-bottom-text'>
              {this.state.bottomMessageFirstHalf}
              </div>
            </div>
          </>
        )
        :(
          <>
            <div className="col-xs-12" style={{ margin: '0' }}>
              <GreyGiftSvg type={greyGiftSvgType} width="15%" height="auto" />
            </div>
            <div className="col-xs-12 bottomMessageFirstHalf">
              {this.state.bottomMessageFirstHalf}
            </div>
            <div className="col-xs-12 bottomMessageSecondHalf">
              {this.state.bottomMessageSecondHalf}
            </div>
          </>
        ))}
      </div>
    );
  }
}

export default EmptyGiftListIndicator;
